module.exports = __webpack_public_path__ + "img/thumbnail_IndianElephant_m_albino.35e2e3a3.png";